import { has, is, prop } from 'ramda';

import { COMMON } from 'translations';

import { withDefault } from './compact';
import { HTTP_CLIENT_ERROR_NOT_FOUND } from './http';

const isObjectWith = (property) => (e) =>
  is(Object, e) && has(property, e) && is(String, prop(property, e));

const isObjectWithMessage = isObjectWith('message');
const isObjectWithStatus = isObjectWith('status');

// We suppose that if a message contains only uppercase chars and underscore, it's a translation key
const isTranslatableMessage = (m) => m.match(/[A-Z_]+/);

const translatable = (m, t, error) => {
  if (isTranslatableMessage(m)) {
    return t(m, prop('context', error));
  }

  return m;
};

const getErrorMessage = (t, error) => {
  return translatable(prop('message', error), t, error);
};

const MESSAGES = {
  [String(HTTP_CLIENT_ERROR_NOT_FOUND)]: COMMON.ERROR_NOT_FOUND,
};

const getErrorMessageFromStatus = (t, error) => {
  const status = prop('status', error);
  return translatable(prop(status, MESSAGES) || COMMON.ERROR_DEFAULT, t, error);
};

export const getErrorObject = (error, message, ctx = {}) => {
  return {
    status: getStatus(error),
    message: message,
    context: ctx,
    raw: isObjectWithMessage(error) ? prop('message', error) : error,
    error,
  };
};

export const getStatus = withDefault('Error', prop('status'));

export const getMessage = (t, error) => {
  if (is(String, error)) {
    return error;
  }

  if (isObjectWithMessage(error) && !(error instanceof TypeError)) {
    return getErrorMessage(t, error);
  }

  if (isObjectWithStatus(error)) {
    return getErrorMessageFromStatus(t, error);
  }

  /* istanbul ignore next */
  if (process.env.RAZZLE_ENV !== 'prod') {
    // eslint-disable-next-line
    console.error(error);
  }

  return is(Function, t) ? t(COMMON.ERROR_DEFAULT) : 'Unexpected error';
};

export class ExtendableError extends Error {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
    /* istanbul ignore next */
    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, this.constructor);
    } else {
      this.stack = new Error(message).stack;
    }
  }
}

export default (status, message, title = undefined, ctx = {}) => ({
  status,
  message,
  context: ctx,
  title: title ? title : status,
});
